// extracted by mini-css-extract-plugin
module.exports = {"inner":"CouponCard_inner__o5EqR","back":"CouponCard_back__JpwMd","more":"CouponCard_more__VdBIh","front":"CouponCard_front__6J_uF"};